import { FormControl, InputLabel, MenuItem } from "@mui/material";
import Select from '@mui/material/Select';

interface SelectProps {
  options: string[] | number[];
  title: string;
  value: string;
  setValue: (value: string) => void;
  size?: 'small' | 'medium';
}

export function SelectComponent ({ options, title, value, setValue, size }: SelectProps) {
  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">{title}</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value?.toString()}
        label={title}
        onChange={(event: any) => setValue(event.target.value as string)}
        size={size}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option?.toString()}>{option?.toString()}</MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
